<template>
  <d2-container>
    <h2>企业认证</h2>
    <el-form ref="elForm" :model="listQuery" size="medium" label-width="100px">
      <el-row type="flex" justify="start" align="top">
        <el-form-item label="注册区县">
          <town-com v-on:on-selectLast="(e)=>listQuery.addressStreetId=e"></town-com>
        </el-form-item>
        <el-form-item label="企业类型">
          <el-select v-model="listQuery.entType" placeholder="请选择企业类型" clearable :style="{width: '100%'}">
            <el-option v-for="(item, index) in entTypeOptions" :key="index" :label="item.label" :value="item.value"
                       :disabled="item.disabled"></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="start">
        <el-form-item  label="企业名称">
          <el-input v-model="listQuery.entName" placeholder="请输入企业名称"
                    clearable :style="{width: '545px'}"></el-input>
        </el-form-item>
        <el-form-item size="large">
          <el-button size="small" class="filter-item" type="primary" icon="search" @click="queryList">查询</el-button>
          <el-button size="small" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-row>
    </el-form>


    <el-tabs v-model="listQuery.isAuth" @tab-click="handleFilter">
      <el-tab-pane label="未认证" name="false"></el-tab-pane>
      <el-tab-pane label="已认证" name="true"></el-tab-pane>
    </el-tabs>
    <el-table
              :data="tableData" size="small" stripe
              highlight-current-row
              style="width: 100%">
      <el-table-column
          type="selection"
          width="55" label="序号">
      </el-table-column>
      <el-table-column
          fixed
          prop="date"
          label="企业名称"
          width="220">
        <template slot-scope="scope">
          <span>{{ scope.row.entName }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="name"
          label="办公地址"
          width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.workAddressName }}/{{ scope.row.workAddressDetail }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="province"
          label="所属街镇"
          width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.addressStreetName }}/{{ scope.row.addressStreetDetail }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="city"
          label="法人代表"
          width="180">
        <template slot-scope="scope">
          <span>{{scope.row.legalName}}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="address"
          label="联系人">
        <template slot-scope="scope">
          <span>{{scope.row.contactName}}</span>
        </template>
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          width="180">
        <template slot-scope="scope">
<!--          <el-button @click="handleClick(scope.row)"  type="text" size="small">查看</el-button>-->
<!--          <el-button type="text" size="small" @click="openAuthEnterprise(scope.row)">认证</el-button>-->

          <el-button size="small" @click="handleClick(scope.row)">查看</el-button>
          <el-button size="small" type="warning" @click="openAuthEnterprise(scope.row)" v-if="!scope.row.isAuth">认证</el-button>
          <el-button size="small" type="warning" v-else @click="openAuthEnterprise(scope.row)">重新认证</el-button>

        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <!--分页-->
    <template slot="footer">
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </template>

    <el-dialog title="企业认证" :visible.sync="isAuthHtml" width="65%" v-if="isAuthHtml">
      <el-form  ref="fromAuth" label-width="150px">
        <el-row type="flex" justify="start" align="top">
          <el-form-item label="企业名称">
            <el-input v-model="fromAuth.eName" placeholder="企业名称" disabled></el-input>
          </el-form-item>
          <el-form-item label="统一社会信息代码">
            <el-input v-model="fromAuth.creditCode" placeholder="统一社会信息代码" disabled></el-input>
          </el-form-item>
        </el-row>
        <el-divider content-position="left">用章人信息</el-divider>
        <el-row style="border-radius: 2px" type="flex" justify="start" align="top">
          <el-form-item label="申请人">
            <el-input v-model="fromAuth.name" placeholder="申请人" v-bind:readonly = "isName"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="fromAuth.phone" placeholder="手机号码" v-bind:readonly="isPhone"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="start" align="top">

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="authCancel()" size="small">关 闭</el-button>
        <el-button size="small" type="primary" @click="authEnterpriseInfo()">确 定</el-button>

      </div>
    </el-dialog>

    <el-dialog title="第三方认证H5界面"  :visible.sync="isH5" width="65%">
      <iframe name="iframe2" id="h5Id" style="width:100%;" height="550px"
              class="iframe" :src="h5Url" frameborder="0"></iframe>

    </el-dialog>

    <el-dialog title="详情" :visible.sync="dialogDetailVisible" v-if="dialogDetailVisible">
      <ent-detail :entId="currentEntId"  @close="close()"></ent-detail>
    </el-dialog>

  </d2-container>
</template>
<script>
import {listPage,enterpriseDetail } from '@/api/admin/sysEnterprise/index';
import {getTree} from '@/api/admin/sysBaseTown/index';
import {enterpriseAuthIns,findByEntId} from '@/api/admin/auth/index';
import TownCom from "../common/town-com.vue";
import EntDetail from "../sysEnterprise/detail.vue";
export default {
  components: {
      TownCom,EntDetail
  },
  data() {
    return {
      dialogDetailVisible: false,
      currentEntId: null,
      listLoading: false,
      listQuery: {
        entName: null,
        entType: null,
        isAuth: "false",
        page: 1,
        limit: 20,
      },
      entTypeOptions: [{
        "label": "加油",
        "value": 0
      }, {
        "label": "供油",
        "value": 1
      }],
      tableData: null,
      total: 0,
      isAuthHtml: false,

      //////////////////认证界面属性配置////////////////////////
      fromAuth: {
          eName:undefined,//企业名称
          entId:undefined,//企业ID
          creditCode:undefined,//信用编号
          name:undefined,//认证人姓名
          phone:undefined,//认证人手机号码

      },
      isH5:false,
      h5Url:undefined,
      isName:false,
      isPhone:false,
      form:{
        parentId:undefined,
      }

    }
  },
  created() {
    this.queryList();
  },
  mounted() {

  },
  methods: {
    //添加成功关闭窗口并进行查询
    handleDetail() {
      this.toExamineVisible = false
      this.queryList();
    },

    //关闭窗口
    closeDetail() {
      this.toExamineVisible = false
    },
    handleFilter() {
        this.queryList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
       this.queryList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
       this.queryList();
    },
    queryList() {
      this.listLoading = true;
      listPage(this.listQuery).then(response => {
        this.tableData = response.rows;
        this.total = response.total;
        this.listLoading = false;
      })
      this.listLoading = false;
    },
    resetForm() {
      this.$refs['elForm'].resetFields()
    },

    openAuthEnterprise(row) {
      //查询数据
      let param = {};
      param.entId = row.entId;
      findByEntId(param).then(result => {
        console.log("result:", result, row)
        this.isAuthHtml = true;
        this.fromAuth.eName = row.entName;
        this.fromAuth.entId = row.entId;
        this.fromAuth.creditCode = row.creditCode;
        this.fromAuth.name = result.name;
        this.fromAuth.phone = result.phone;
        if(result.status==1){
          this.isPhone = true;
          this.isName = true;
        }else{
          this.isPhone = false;
          this.isName = false;
        }
      })

    },
    authCancel() {
      this.isAuthHtml = false;
      this.queryList();
    },
    authEnterpriseInfo() {
      let authObj = {};
      authObj.entId = this.fromAuth.entId;
      authObj.name = this.fromAuth.name;
      authObj.phone =this.fromAuth.phone;
      enterpriseAuthIns(authObj).then(result => {
        if(result.auth){
          this.$notify({
            title: '警告',
            message: '当前企业已认证，无需重复认证',
            type: 'warning',
            duration: 2000
          });
          this.isAuthHtml = false;
        }else{
          this.h5Url = result.h5Url;
          this.isH5 = true;
        }
      });
    },
    handleClick(row) {
        //详情
        this.dialogDetailVisible=true;
        this.currentEntId = row.entId;
    },
    close(flush){
        this.dialogFormVisible=false;
        this.dialogAuditVisible=false;
        this.dialogDetailVisible=false;
        this.dialogServiceVisible=false;
        flush && this.getList();
    },
  }
}
</script>
<style>
</style>
